export default __webpack_public_path__ + "static/media/website.074254d1.svg";